import React, { useState, useEffect } from 'react';
import { Card, Form, Input, InputNumber, Switch, Button, message, Tabs, Divider } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import './index.css';

const { TextArea } = Input;

const Settings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 获取配置
  const fetchSettings = async () => {
    try {
      // TODO: 调用实际API
      // const response = await getSettings();
      // form.setFieldsValue(response.data);
      
      // 模拟数据
      form.setFieldsValue({
        systemName: 'ZJSSO',
        systemDescription: '单点登录系统',
        tokenExpire: 7200,
        refreshTokenExpire: 604800,
        allowRegister: true,
        requireEmailVerify: false,
        maxLoginAttempts: 5,
        lockoutDuration: 30,
        sessionTimeout: 1800,
      });
    } catch (error) {
      message.error('获取配置失败');
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // 保存配置
  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      
      // TODO: 调用实际API
      // await updateSettings(values);
      
      setTimeout(() => {
        message.success('保存成功');
        setLoading(false);
      }, 500);
    } catch (error) {
      message.error('保存失败');
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="page-header">
        <h2>系统配置</h2>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSave}
          loading={loading}
        >
          保存配置
        </Button>
      </div>

      <Form form={form} layout="vertical">
        <Tabs defaultActiveKey="basic" items={[
          {
            key: 'basic',
            label: '基础配置',
            children: (
            <Card title="系统信息" style={{ marginBottom: 16 }}>
              <Form.Item
                name="systemName"
                label="系统名称"
                rules={[{ required: true, message: '请输入系统名称' }]}
              >
                <Input placeholder="请输入系统名称" />
              </Form.Item>

              <Form.Item
                name="systemDescription"
                label="系统描述"
              >
                <TextArea rows={4} placeholder="请输入系统描述" />
              </Form.Item>
            </Card>
            ),
          },
          {
            key: 'token',
            label: 'Token配置',
            children: (
            <Card title="Token设置" style={{ marginBottom: 16 }}>
              <Form.Item
                name="tokenExpire"
                label="Token过期时间（秒）"
                rules={[{ required: true, message: '请输入Token过期时间' }]}
              >
                <InputNumber
                  min={60}
                  max={86400}
                  style={{ width: '100%' }}
                  placeholder="默认7200秒（2小时）"
                />
              </Form.Item>

              <Form.Item
                name="refreshTokenExpire"
                label="Refresh Token过期时间（秒）"
                rules={[{ required: true, message: '请输入Refresh Token过期时间' }]}
              >
                <InputNumber
                  min={3600}
                  max={2592000}
                  style={{ width: '100%' }}
                  placeholder="默认604800秒（7天）"
                />
              </Form.Item>
            </Card>
            ),
          },
          {
            key: 'security',
            label: '安全配置',
            children: (
            <Card title="安全设置" style={{ marginBottom: 16 }}>
              <Form.Item
                name="allowRegister"
                label="允许用户注册"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="requireEmailVerify"
                label="需要邮箱验证"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Divider />

              <Form.Item
                name="maxLoginAttempts"
                label="最大登录尝试次数"
                rules={[{ required: true, message: '请输入最大登录尝试次数' }]}
              >
                <InputNumber
                  min={3}
                  max={10}
                  style={{ width: '100%' }}
                  placeholder="默认5次"
                />
              </Form.Item>

              <Form.Item
                name="lockoutDuration"
                label="账户锁定时长（分钟）"
                rules={[{ required: true, message: '请输入账户锁定时长' }]}
              >
                <InputNumber
                  min={5}
                  max={1440}
                  style={{ width: '100%' }}
                  placeholder="默认30分钟"
                />
              </Form.Item>

              <Form.Item
                name="sessionTimeout"
                label="会话超时时间（秒）"
                rules={[{ required: true, message: '请输入会话超时时间' }]}
              >
                <InputNumber
                  min={300}
                  max={7200}
                  style={{ width: '100%' }}
                  placeholder="默认1800秒（30分钟）"
                />
              </Form.Item>
            </Card>
            ),
          },
        ]} />
      </Form>
    </div>
  );
};

export default Settings;

